export const messages = {
  en: {
    staffDetailInfo: {
      title: 'Staff Information',
      staffId: 'ID:',
      userName: 'Name:',
      email: 'Email:',
      tel: 'Phone:',
      sex: 'Gender:',
      address: 'Address:',
      male: 'Male',
      female: 'Female',
      relatedOrg: 'Related Organization',
      relatedRoleAndShop: 'Related Roles and Shops',
      staffPrivilege: 'Staff Privileges',
      org: 'Organization',
      staffIdRequired: 'Staff ID is required'
    }
  },
  zh: {
    staffDetailInfo: {
      title: '员工信息',
      staffId: '编号：',
      userName: '名称：',
      email: '邮箱：',
      tel: '手机：',
      sex: '性别：',
      address: '住址：',
      male: '男',
      female: '女',
      relatedOrg: '关联组织',
      relatedRoleAndShop: '关联角色及店铺',
      staffPrivilege: '员工权限',
      org: '组织',
      staffIdRequired: '员工ID不能为空'
    }
  }
}